import { memo } from 'react';

import CookieOutlined from '@mui/icons-material/CookieOutlined';
import { Box, Link, Paper, Typography } from '@mui/material';

import Button from '@/components/Buttons/Button';
import { Z_INDEX } from '@/constants/z-index';

const CookieBannerFull = ({
  handleAccept,
  handleDecline
}: {
  handleAccept: () => void;
  handleDecline: () => void;
}) => {
  return (
    <Paper
      elevation={3}
      sx={theme => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        px: 3,
        py: 7,
        zIndex: Z_INDEX.cookieBanner,
        [theme.breakpoints.up('xl')]: {
          left: 'calc(50% - 1015px)'
        }
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 60,
          maxWidth: 1000,
          mx: 'auto'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyItems: 'flex-start',
            alignItems: 'center'
          }}
        >
          <CookieOutlined sx={{ fontSize: 64 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', px: 3 }}>
            <Typography>
              To ensure the best experience this application uses cookies as outlined in our{' '}
              <Link
                href='https://www.general-index.com/privacy-cookies'
                rel='noopener'
                target='_blank'
                underline='none'
              >
                Privacy Policy
              </Link>
              . Cookies are required for the app to work correctly. Declining cookies will disable
              essential features and you won’t be able to use the app. Do you wish to decline
              cookies?
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            flexShrink: 0,
            gap: 2.5
          }}
        >
          <Button
            sx={{
              width: 174
            }}
            variant='outlined'
            onClick={handleDecline}
          >
            Decline
          </Button>
          <Button
            sx={{ width: 174 }}
            variant='contained'
            onClick={handleAccept}
          >
            <CookieOutlined />
            Accept Cookies
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default memo(CookieBannerFull);
